import { memo, useEffect } from "react";
import { connect } from "react-redux";
import { PacienteViewProps, mapDispatchToPacienteProps, mapStateToPacienteProps } from "../paciente.controller";
import { Autocomplete, Box, IconButton, Stack, TextField, Typography } from "@mui/material";
import { Paciente } from "../paciente.model";
import { ArrowDropDown, Search } from "@mui/icons-material";
import { ClearIcon } from "@mui/x-date-pickers";
import Modal from "../../../components/modal";
import { columnsPaciente } from "./paciente.list";
import { Select as ViewList } from "../../../components/select";
import { PacienteCadastro } from "./paciente.cad";
import store from "../../../store";


interface PacienteAutoCompletProps extends PacienteViewProps {
    handleSelectPaciente: (row: Paciente) => any
}


function PacienteAutoComplete(props: PacienteAutoCompletProps) {
    const { pacienteActions, pacienteState, handleSelectPaciente } = props
    const { rows } = pacienteState
    useEffect(() => {
        console.log("chamou read paciente PacienteAutoComplete")
        pacienteActions.read();
    }, [])

    const handleSelect = (row: Paciente) => {
        console.log("selecionou paciente " + row)
        handleSelectPaciente(row)
    }

    return (
        <Autocomplete
            fullWidth
            options={rows}
            autoHighlight
            getOptionLabel={(row) => row.nome}
            getOptionKey={(row) => row._id}
            title="Selecionar Paciente"
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            disableClearable
            //popupIcon={<Search fontSize="small"  titleAccess="Selecionar Paciente"/>}
            clearIcon={<ClearIcon fontSize="small" titleAccess="Remover" />}
            renderOption={((props, paciente) => {
                const { key, ...optionProps } = props
                return (
                    <Box
                        key={key}
                        component={"li"}
                        {...optionProps}
                    >
                        <Stack flexDirection={"column"}>
                            <Typography variant="body1">{paciente.nome}</Typography>
                        </Stack>
                    </Box>
                )
            })}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label="Selecionar Paciente"
                    slotProps={{
                        htmlInput: {
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        },
                    }}
                />
            }
            onChange={(ev, paciente) => {
                ev.preventDefault();
                if (paciente)
                    handleSelect(paciente);
            }}
        />
    )
}
interface SelecionarPacienteProps extends PacienteViewProps {
    handleConfirmar: (paciente: Paciente) => any;
}

const SelecionarPaciente = memo((props: SelecionarPacienteProps) => {
    const { pacienteActions, pacienteState, handleConfirmar } = props
    const { error, loadingRows, msg, row, rows, showAlert, status, showCadModal, changeList, showSelectModal } = pacienteState
    const { read, setShowAlert, setClearValue, setShowCadModal, setShowSelectModal } = pacienteActions

    console.log("carregou selecionar paciente")

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    function Cadastro() {
        return PacienteCadastro({
            ...props,
            handleCloseView: () => setShowCadModal(false)
        }).renderModal({
            handleClose: () => setShowCadModal(false),
            show: showCadModal,
            heigth: "auto",
            width: "sm",
        })
    }

    const handleSelecionar = (paciente: Paciente) => {
        handleConfirmar(paciente);
        setShowSelectModal(false);
    }

    const List = () => {
        return (
            <>
                <ViewList
                    displayWidth={window.innerWidth}
                    title={"Selecionar Paciente"}
                    row={row}
                    showAlert={showAlert}
                    closeAlert={() => setShowAlert(false)}
                    msg={msg}
                    status={status}
                    elevation={1}
                    getRowId={(row: Paciente) => row._id}
                    handleOnChange={handleSelecionar}
                    actionsOnkeyEnter={handleSelecionar}
                    showSearchContainer={true}
                    fontSize={20}
                    setTextSearch={() => { }}
                    textSearch={""}
                    multFieldSearch
                    fieldSearch={["nome", "whatsapp"]}
                    placeholderTextSearch="Buscar paciente"
                    variantToobar="dense"
                    columns={columnsPaciente}
                    rows={rows}
                    loading={loadingRows}
                    setRow={handleSelecionar}
                    changeList={changeList}
                    buttonNew={{
                        show: true,
                        onClick: handleNovo
                    }}
                    buttonRefresh={{
                        show: true,
                        onClick: () => read()
                    }}
                    ListItemTextPrimary={(row: Paciente) => <Typography component={"span"}>{row.nome}</Typography>}
                />
                <Cadastro />
            </>
        )
    }

    return (
        <Modal
            component={<List />}
            handleClose={() => setShowSelectModal(false)}
            open={showSelectModal}
            heigth="auto"
            width="md"
            handleOnKeyDown={() => { }}
        />
    )
},(prev,next)=>{
    return prev.pacienteState.showSelectModal === next.pacienteState.showSelectModal&&
    prev.pacienteState.changeList === next.pacienteState.changeList&&
    prev.pacienteState.showCadModal === next.pacienteState.showCadModal
})

export default connect(mapStateToPacienteProps, mapDispatchToPacienteProps)(PacienteAutoComplete)
export const ViewSelecionarPaciente = connect(mapStateToPacienteProps, mapDispatchToPacienteProps)(SelecionarPaciente)
